<template>
  <div class="panel-group">
    <div
      class="panel panel-default panel-default--transparent panel-toggle"
      v-for="standard in standards"
      :key="standard.standard_long_ref"
      :class="{active: showPanel[standard.standard_long_ref]}">
      <div
        class="panel-heading ellipsis"
        role="button"
        :title="panelHeaderTextForStandard(standard)"
        @click="togglePanel(standard.standard_long_ref, {registerAnalytics: true})"
        @keypress.enter="togglePanel(standard.standard_long_ref, {registerAnalytics: true})"
        :aria-expanded="showPanel[standard.standard_long_ref] ? 'true' : 'false'"
        tabindex="0"
        v-html="panelHeaderTextForStandard(standard)"/>
      <collapse v-model="showPanel[standard.standard_long_ref]">
        <StandardView
          class="panel-body"
          :set-code="standard.standard_set_code"
          :long-ref="standard.standard_long_ref"
          :short-ref="standard.standard_short_ref"
          :standard-text="standard.standard_text"
          :core-purpose="standard.core_purpose"
          :info-obj="standard"
          :edit-link="showEditLink && editStandard(standard) || ''" />
      </collapse>
    </div>
  </div>
</template>

<script>
import { toolkitUrls, pathwaysUrls } from '@/links'
import { mapState, mapActions } from 'vuex'
import StandardView from '@/standards/StandardView.vue'
import { panelHeaderTextForStandard } from '@/components/goals/common/standard_panel_header_text.js'

export default {
  name: 'StandardsAccordion',
  components: { StandardView },
  props: {
    standards: {
      type: Array,
      default() {
        return []
      }
    },
    showEditLink: {
      type: Boolean,
      default: false
    },
    shouldExpandFirstStandard: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPanel: {}
    }
  },
  computed: {
    ...mapState('goaldetail', {
      migratedStandardSets(state) {
        return state.validStandardSets || []
      }
    })
  },
  methods: {
    ...mapActions('goaldetail', ['fetchValidStandardSets']),
    togglePanel(standardLongRef, options = {}) {
      this.$set(this.showPanel, standardLongRef, !this.showPanel[standardLongRef] || options.show)
      Object.keys(this.showPanel).forEach(key => {
        if (key !== standardLongRef) {
          this.showPanel[key] = false
        }
      })

      if (options.registerAnalytics) {
        this.$sendEvent('Clicked Standard Accordion', {
          standard_long_ref: standardLongRef
        })
      }
    },
    panelHeaderTextForStandard(standard) {
      return panelHeaderTextForStandard(standard)
    },
    editStandard(standard) {
      if (this.migratedStandardSets.indexOf(standard.standard_set_code) > -1) {
        return pathwaysUrls.editStandard(standard.standard_set_code, standard.standard_long_ref)
      }
      return toolkitUrls.editorLinks.editStandard(standard.uuid)
    },
    expandFirstStandard() {
      if (this.standards && this.standards.length > 0) {
        if (this.shouldExpandFirstStandard) {
          this.togglePanel(this.standards[0].standard_long_ref, { show: true })
        }
      }
    }
  },
  watch: {
    standards() {
      this.expandFirstStandard()
    }
  },
  created() {
    this.expandFirstStandard()
    if (this.showEditLink) {
      this.fetchValidStandardSets()
    }
  }
}
</script>
